/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.9.3",
    versionName: "0.2.0-nightly.2025.9.3",
    versionChannel: "nightly",
    buildDate: "2025-09-03T00:07:02.530Z",
    commitHash: "b1f47346993e21f7d8ca95a0b9edb4cb8817ca53",
};
